module.exports = __webpack_public_path__ + "media/images/icon-version@3x-201f6d05935fffedc40ce4c08aeb4612.png";